export default function Component(props) {
  return (
    <div className="col-lg-3 col-sm-8 col-10 d-flex flex-column justify-content-between rounded-4 overflow-hidden p-0 shadow mb-5">
      <div className="card p-4">
        <div
          className="team-image rounded-4"
          style={{
            backgroundImage: `url(${props?.image})`,
          }}
          alt={props.name}
        />
        <h5 className="mt-4 text-primary2 fw-semibold">{props.name}</h5>
        <p className="mt-1 mb-4 fw-semibold">
          {props.position}, Asal dari {props.address}
        </p>
        <p className="normal text-secondary">{props.desc}</p>
      </div>
      <a
        target="_blank"
        rel="noreferrer"
        className="btn btn-primary2 text-white fw-medium rounded-0 w-100 py-25"
        href={props.linkedin}
      >
        <i className="fa-brands fa-linkedin-in me-3"></i>
        Linkedin
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        className="btn btn-primary2 text-white fw-medium rounded-0 w-100 py-25"
        href={props.github}
      >
        <i className="fa-brands fa-github me-3"></i>
        Github
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        className="btn btn-primary2 text-white fw-medium rounded-0 w-100 py-25"
        href={props.instagram}
      >
        <i className="fa-brands fa-instagram me-3"></i>
        Instagram
      </a>
    </div>
  );
};
